<template>
  <div class="filter-bar">
    <ul ref="navBar" class="search-filter-bar">
      <li class="all" @click="switchAllSort">
        <div
          :class="{ 'integrated-selected': allSort, ...themeAppColorClass }"
          class="all-text"
        >
          {{ class2Name }}
        </div>
        <div class="tag all-tag">
          <img v-show="allSort && allUp" :src="fileterAllUpImg" />
          <img v-show="allSort && allDown" :src="fileterAllDownImg" />
          <img
            v-show="!allSort && allUp"
            src="@/images/activity_goods/all_up.png"
          />
          <img
            v-show="!allSort && allDown"
            src="@/images/activity_goods/all_down.png"
          />
        </div>
      </li>
      <li class="price" @click="switchPriceSort">
        <span :class="{ 'price-selected': priceSort, ...themeAppColorClass }"
          >价格</span
        >
        <div class="tag price-tag">
          <img v-show="priceSort && increment" :src="fileterUpImg" alt="" />
          <img
            v-show="decrement"
            src="@/images/activity_goods/up-nor.png"
            alt=""
          />
          <img v-show="priceSort && decrement" :src="fileterDownImg" alt="" />
          <img
            v-show="increment"
            src="@/images/activity_goods/d-nor.png"
            alt=""
          />
        </div>
      </li>
      <li class="filter" @click="switchFilter">
        <span :class="{ 'instock-selected': filterSort, ...themeAppColorClass }"
          >筛选</span
        >
        <div class="tag filer-tag">
          <img v-if="filterSort" :src="fileterActiveImg" />
          <img v-else src="@/images/activity_goods/filter.png" />
        </div>
      </li>
    </ul>

    <!-- 蒙版 -->
    <mc-mask
      :show="isShowMask"
      :top="maskTop"
      :z-index="isShowMask ? '500' : '110'"
      :prevent-move="false"
      @clickMask="switchMask"
    >
      <select-all
        :all-sort.sync="allSort"
        :price-sort.sync="priceSort"
        :decrement.sync="decrement"
        :increment.sync="increment"
        :all-up.sync="allUp"
        :all-down.sync="allDown"
        :all-defalut.sync="allDefalut"
        @closeMask="closeMask"
        @activitySkuListOptimize="activitySkuListOptimize"
      ></select-all>
    </mc-mask>
  </div>
</template>

<script>
import McMask from '@/common/widgets/mask'
import selectAll from './SelectAll.vue'
import { mapState, mapActions } from 'vuex'
import themeMixin from '@/common/mixins/theme'
import {
  fileterAllDownImg,
  fileterAllUpImg,
  fileterDownImg,
  fileterActiveImg,
  fileterUpImg
} from '@/defines/environment/config'
export default {
  name: 'SearchFilterBar',
  components: { McMask, selectAll },
  mixins: [themeMixin],
  // eslint-disable-next-line vue/require-prop-types
  props: ['searchSku', 'pageName'],
  data() {
    return {
      allSort: false,
      allUp: false,
      allDown: true,
      increment: true,
      decrement: true,
      priceSort: false,
      isShowMask: false,
      allDefalut: true,
      fileterAllDownImg,
      fileterAllUpImg,
      fileterDownImg,
      fileterActiveImg,
      fileterUpImg
    }
  },
  computed: {
    ...mapState('activityGoods', {
      class2Name: state => state.class2Name,
      queryData: state => state.queryData,
      filterSort: state => state.filterSort,
      clearStateData: state => state.clearStateData
    }),
    maskTop() {
      return 84 + this.statusBarHeight
    }
  },
  created() {
    this.clearData()
  },
  deactivated() {
    if (this.clearStateData) {
      this.clearData()
    }
  },
  destroyed() {
    if (this.clearStateData) {
      this.clearData()
    }
  },

  methods: {
    ...mapActions('activityGoods', [
      'openFilter',
      'setActQueryData',
      'clearSkuList'
    ]),
    activitySkuListOptimize() {
      this.$emit('activitySkuListOptimize')
    },
    switchAllSort() {
      this.$track(this.$trackMap.activityGoods.clickClassify)
      this.allUp = true
      this.allDown = false
      this.isShowMask = true
    },
    switchPriceSort() {
      this.$track(this.$trackMap.activityGoods.sortPrice)
      this.priceSort = true
      const flag = !this.decrement
      this.decrement = flag
      this.increment = !flag
      const sortType = this.decrement ? 2 : 1
      this.setQueryData('sortType', sortType)
      this.setQueryData('page', 0)
      this.clearSkuList()
      this.activitySkuListOptimize()
    },
    setQueryData(name, data) {
      const queryObj = {}
      queryObj[name] = data
      this.setActQueryData(queryObj)
    },
    switchFilter() {
      this.$track(this.$trackMap.activityGoods.clickFilter)
      this.openFilter()
    },
    closeMask() {
      this.isShowMask = false
      this.$emit('update:isShowMask', this.isShowMask)
    },
    switchMask() {
      if (this.allDefalut) {
        this.allSort = false
      } else {
        this.allSort = true
      }
      this.allUp = false
      this.allDown = true
      this.closeMask()
    },
    clearData() {
      this.allSort = false
      this.allUp = false
      this.allDown = true
      this.increment = true
      this.decrement = true
      this.priceSort = false
      this.isShowMask = false
      this.allDefalut = true
    }
  }
}
</script>

<style lang="scss" scoped>
.search-filter-bar {
  display: flex;

  height: 40px;

  // border-bottom: 1px solid #f3f3f3;

  justify-content: space-between;

  white-space: nowrap;

  li {
    display: flex;

    align-items: center;

    font-size: 0.28rem;
    font-weight: 700;
    color: #333333;
    &.all,
    &.filter {
      width: 2.16rem;

      justify-content: center;
    }
    .all-text {
      max-width: 1.6rem;

      font-size: 0.28rem;
      line-height: 0.3rem;

      @include text-overflow-ellipsis-single;
    }
  }
}
.price-selected,
.instock-selected,
.integrated-selected {
  color: #0daf52;
  &.small {
    color: $theme-main_small;
  }
}

.tag {
  display: flex;

  margin-left: 3px;
  &.all-tag {
    img {
      height: 0.06rem;
    }
  }
  &.price-tag {
    width: 0.1rem;
    height: 0.16rem;

    flex-direction: column;
    justify-content: space-between;

    img {
      width: 0.1rem;
      height: 3px;
    }
  }
  &.filer-tag {
    img {
      height: 0.2rem;
    }
  }
}
.filter-bar {
  width: 100%;

  background-color: #fff;
}
</style>
